import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    fetchCustomers: ['query', 'query'],
    fetchCustomersSuccess: ['items', 'pagination'],
    fetchCustomersFailure: ['error'],

    fetchFlatCustomers: ['query', 'query'],
    fetchFlatCustomersSuccess: ['items'],
    fetchFlatCustomersFailure: ['error'],

    createCustomer: ['customer', 'query'],
    createCustomerSuccess: ['customer'],
    createCustomerFailure: ['error'],

    fetchCustomer: ['id', 'query'],
    fetchCustomerSuccess: ['customer'],
    fetchCustomerFailure: ['error'],

    updateCustomer: ['id', 'customer', 'query'],
    updateCustomerSuccess: ['customer'],
    updateCustomerFailure: ['error'],

    deleteCustomer: ['id', 'query'],
    deleteCustomerSuccess: ['items'],
    deleteCustomerFailure: ['error'],
});


export const CustomerTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    loading: false,
    error: null,
    items: [],
    flat_customers: [],
    customer: null,
    pagination: null,
    deletedItem: null,
    lastSyncDt: null,
    updatedDt: null,
})

const resetState = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {

    // Fetch work order actions
    [Types.FETCH_CUSTOMERS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            items: [],
        };
    },

    [Types.FETCH_CUSTOMERS_SUCCESS]: (state, {items, pagination}) => {
        return {
            ...state,
            items,
            pagination,
            loading: false,
            error: null,
            lastSyncDt: new Date().getTime(),
        };
    },

    [Types.FETCH_CUSTOMERS_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            items: [],
        };
    },

    // Fetch work order actions
    [Types.FETCH_FLAT_CUSTOMERS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            flat_customers: [],
        };
    },

    [Types.FETCH_FLAT_CUSTOMERS_SUCCESS]: (state, {items}) => {
        return {
            ...state,
            flat_customers: items,
            loading: false,
            error: null,
        };
    },

    [Types.FETCH_FLAT_CUSTOMERS_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            flat_customers: [],
        };
    },

    // Create an work order
    [Types.CREATE_CUSTOMER]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            customer: null,
        };
    },

    [Types.CREATE_CUSTOMER_SUCCESS]: (state, { customer }) => {
        return {
            ...state,
            loading: false,
            customer,
            error: null,
        };
    },

    [Types.CREATE_CUSTOMER_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            customer: null,
        };
    },

    // Fetch a single work order
    [Types.FETCH_CUSTOMER]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            customer: null,
            updatedDt: null,
        };
    },

    [Types.FETCH_CUSTOMER_SUCCESS]: (state, {customer}) => {
        return {
            ...state,
            loading: false,
            error: null,
            customer,
            updatedDt: null,
        };
    },

    [Types.FETCH_CUSTOMER_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            customer: null,
        };
    },

    // Update an work order
    [Types.UPDATE_CUSTOMER]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            updatedDt: null,
        };
    },

    [Types.UPDATE_CUSTOMER_SUCCESS]: (state, {customer}) => {
        return {
            ...state,
            loading: false,
            customer,
            error: null,
            updatedDt: new Date().getTime(),
        };
    },

    [Types.UPDATE_CUSTOMER_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            updatedDt: null,
        };
    },

    // Delete an existing work order
    [Types.DELETE_CUSTOMER]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            deletedItem: null,
            updatedDt: null,
        };
    },

    [Types.DELETE_CUSTOMER_SUCCESS]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: null,
            deletedItem: true,
        };
    },

    [Types.DELETE_CUSTOMER_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            deletedItem: null,
        };
    },
});



// WEBPACK FOOTER //
// ./src/Redux/CustomerRedux.js